<template>
  <BaseCard>
    <div
      :class="$style.base"
      v-test="`new-feature-card-${featureName}`"
    >
      <div>
        <BaseLabel
          :mb="0.5"
          color="primary"
        >
          {{ $t('dashboard.new_feature_card.label') }}
        </BaseLabel>
        <BaseText
          :mb="0.5"
          bold
        >
          {{ $t(`dashboard.new_feature_card.${featureName}.title`) }}
        </BaseText>
        <BaseText :mb="0.5">
          {{ $t(`dashboard.new_feature_card.${featureName}.description`) }}
        </BaseText>
        <BaseText
          :href="helpCenterArticleUrl($t(`dashboard.new_feature_card.${featureName}.link_url`))"
        >
          {{ $t(`dashboard.new_feature_card.${featureName}.link_cta`) }}
        </BaseText>
      </div>
      <div
        v-if="$screen !== 's'"
        :class="$style.imageContainer"
      >
        <img src="/img/dashboard/gift.svg">
      </div>
    </div>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { helpCenterArticleUrl } from '@/helpers/help-center';

defineProps<{
  featureName: 'waiting_list_per_day';
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
}

.imageContainer {
  display: flex;
  align-items: center;
  margin-left: $spacing;
}
</style>
